(() => {
  'use strict';
  const configNode = document.getElementById('CooshierConfig');
  if (!configNode || !window.CooshierCommerce) return;
  const config = JSON.parse(configNode.textContent);
  const C = window.CooshierCommerce;
  const strings = config.strings || {};
  const t = key => strings[key] || key.replaceAll('_', ' ');
  const money = value => new Intl.NumberFormat(config.locale || 'en', {style:'currency',currency:config.currency || 'EUR'}).format(value / 100);
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const status = message => { const el = document.getElementById('GlobalStatus'); if (el) el.textContent = message; };
  const openDialog = dialog => { if (dialog && !dialog.open) dialog.showModal(); };
  const closeDialog = dialog => { if (dialog?.open) dialog.close(); };
  const cartSectionIds = () => ['cart-drawer', document.querySelector('[data-cart-page]')?.dataset.sectionId].filter(Boolean);
  let cartBusy = false;

  async function api(endpoint, payload) {
    const response = await fetch(`${root}${endpoint}`, {
      method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({...payload,sections:cartSectionIds(),sections_url:location.pathname})
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400) {
      const message = typeof result.description === 'string' ? result.description : t('error');
      throw new Error(message);
    }
    return result;
  }

  async function renderCart(sections) {
    let source = sections?.['cart-drawer'];
    if (!source) {
      const response = await fetch(`${root}?sections=${cartSectionIds().join(',')}`, {credentials:'same-origin',headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error(t('error'));
      sections = await response.json(); source = sections['cart-drawer'];
    }
    const parsed = new DOMParser().parseFromString(source || '', 'text/html');
    const next = parsed.getElementById('CartDrawerContent');
    const current = document.getElementById('CartDrawerContent');
    if (!next || !current) throw new Error(t('error'));
    current.replaceChildren(...Array.from(next.childNodes));
    const count = parsed.querySelector('[data-cart-count]')?.textContent || '0';
    document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent = count;});
    const page = document.querySelector('[data-cart-page]');
    if (page && sections?.[page.dataset.sectionId]) {
      const nextPage = new DOMParser().parseFromString(sections[page.dataset.sectionId], 'text/html').querySelector('[data-cart-page]');
      if (nextPage) page.replaceWith(nextPage);
    }
    document.dispatchEvent(new CustomEvent('cooshier:cart-updated', {detail:{count:Number(count)}}));
  }

  async function updateCart(key, quantity, focusHint) {
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    cartBusy = true;
    const roots = [document.getElementById('CartDrawer'),document.querySelector('[data-cart-page]')].filter(Boolean);
    roots.forEach(el => { el.setAttribute('aria-busy','true'); el.querySelectorAll('button,input').forEach(control => {control.disabled=true;}); });
    document.querySelectorAll('[data-cart-error]').forEach(el => {el.textContent='';});
    try {
      const result = await api('cart/change.js', {id:key,quantity});
      await renderCart(result.sections);
      status('Bag updated.');
      const scope = document.getElementById('CartDrawer')?.open ? document.getElementById('CartDrawer') : document.querySelector('[data-cart-page]');
      const target = Array.from(scope?.querySelectorAll('[data-key]') || []).find(el => el.dataset.key===key && el.matches(focusHint || 'input'));
      (target || scope?.querySelector('[data-dialog-close],a,button'))?.focus();
    } catch (error) {
      document.querySelectorAll('[data-cart-error]').forEach(el => {el.textContent=error.message || t('error');});
    } finally {
      cartBusy = false;
      roots.forEach(el => {el.removeAttribute('aria-busy');el.querySelectorAll('button,input').forEach(control => {control.disabled=false;});});
    }
  }

  document.addEventListener('click', event => {
    const open = event.target.closest('[data-dialog-open]');
    if (open) {event.preventDefault();openDialog(document.getElementById(open.dataset.dialogOpen));return;}
    const close = event.target.closest('[data-dialog-close]');
    if (close) {closeDialog(close.closest('dialog'));return;}
    const cart = event.target.closest('[data-cart-open]');
    if (cart && !event.metaKey && !event.ctrlKey) {event.preventDefault();openDialog(document.getElementById('CartDrawer'));return;}
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {event.preventDefault();updateCart(remove.dataset.key,0);return;}
    const change = event.target.closest('[data-cart-delta]');
    if (change) {
      const input = change.closest('.quantity-control').querySelector('input');
      const step = Number(input.step)||1;
      updateCart(change.dataset.key,Math.max(0,Number(input.value)+Number(change.dataset.cartDelta)*step),`[data-cart-delta="${change.dataset.cartDelta}"]`);
    }
    const gallery = event.target.closest('[data-gallery-select]');
    if (gallery) showMedia(gallery.closest('[data-gallery]'),gallery.dataset.gallerySelect);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-quantity]')) updateCart(event.target.dataset.key,Number(event.target.value),'input');
  });
  document.addEventListener('click', event => {
    if (event.target.tagName === 'DIALOG') {
      const box=event.target.getBoundingClientRect();
      if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom) closeDialog(event.target);
    }
  });
  document.addEventListener('shopify:section:unload', event => {event.target.querySelectorAll('dialog[open]').forEach(closeDialog);});

  function showMedia(gallery,id) {
    if (!gallery) return;
    const slides=gallery.querySelectorAll('[data-media-id]');
    if (!Array.from(slides).some(slide=>slide.dataset.mediaId===String(id))) return;
    slides.forEach(slide=>{slide.hidden=slide.dataset.mediaId!==String(id);if(slide.hidden)slide.querySelectorAll('video').forEach(video=>video.pause());});
    gallery.querySelectorAll('[data-gallery-select]').forEach(button=>button.setAttribute('aria-current',String(button.dataset.gallerySelect===String(id))));
  }

  class CooshierProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const data=this.querySelector('[data-product-json]');
      if(!data) return;
      this.initialized=true;
      this.product=JSON.parse(data.textContent);
      this.form=this.querySelector('.purchase-form');
      this.choices=new Array(this.product.optionCount).fill(null);
      this.salesEnabled=this.dataset.salesEnabled==='true';
      this.subscriptionsEnabled=this.dataset.subscriptionsEnabled==='true';
      this.purchaseType=null;this.planId=null;this.busy=false;
      this.variantInput=this.form.querySelector('[name="id"]');
      this.planInput=this.form.querySelector('[name="selling_plan"]');
      this.quantityInput=this.form.querySelector('[name="quantity"]');
      this.button=this.querySelector('[data-add-to-cart]');
      this.error=this.querySelector('[data-product-error]');
      this.querySelectorAll('[data-native-options],[data-native-plans]').forEach(el=>{el.hidden=true;});
      this.querySelectorAll('[data-enhanced-options],[data-enhanced-purchase]').forEach(el=>{el.hidden=false;});
      // Custom guidance replaces the native invisible-select validation UI.
      this.form.noValidate=true;
      const deepVariant=new URL(location.href).searchParams.get('variant');
      const initial=this.product.variants.find(v=>String(v.id)===deepVariant);
      if(initial) this.choices=[...initial.options];
      if(this.product.variants.length===1 && this.product.variants[0].options[0]==='Default Title'){
        this.choices=[...this.product.variants[0].options];this.querySelector('[data-enhanced-options]').hidden=true;
      }
      this.querySelectorAll('[data-option-index]').forEach(field=>{
        const index=Number(field.dataset.optionIndex);
        field.querySelectorAll('input').forEach(input=>{
          input.checked=this.choices[index]===input.value;
          // Weight metadata is only shown for unambiguous size-only products.
          const v=this.product.optionCount===1?this.product.variants.find(v=>v.options[index]===input.value):null;
          const weight=input.parentElement.querySelector('[data-weight-label]');
          if(weight&&v?.weightRange) weight.textContent=v.weightRange;
        });
      });
      this.form.addEventListener('change',event=>{
        this.error.textContent='';
        if(event.target.matches('[data-option-value]')){
          const index=Number(event.target.closest('[data-option-index]').dataset.optionIndex);
          this.choices[index]=event.target.value;
        }
        if(event.target.name==='purchase-choice'){
          this.purchaseType=event.target.value;
          if(this.purchaseType==='subscription') this.planId=this.allocations?.[0]?.planId || null;
          else this.planId=null;
        }
        if(event.target.matches('[data-frequency]'))this.planId=event.target.value;
        this.update();
      });
      this.form.addEventListener('click',event=>{
        const control=event.target.closest('[data-quantity-delta]');
        if(!control)return;
        const rule=this.variant?.quantityRule||{},step=rule.increment||1,min=rule.min||1,max=rule.max||Infinity;
        const value=Number(this.quantityInput.value)||min;
        this.quantityInput.value=String(Math.max(min,Math.min(max,value+Number(control.dataset.quantityDelta)*step)));
        this.update();
      });
      this.form.addEventListener('submit',event=>{event.preventDefault();this.submit();});
      this.querySelector('[data-sticky-action]')?.addEventListener('click',()=>{
        this.form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
        (this.querySelector('[data-option-value]:not(:checked)')||this.button).focus({preventScroll:true});
      });
      const sticky=this.querySelector('[data-sticky-buy]');
      if(sticky&&'IntersectionObserver'in window){
        this.observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting || this.getBoundingClientRect().bottom<0;},{threshold:0});
        this.observer.observe(this.button);
      }
      this.update();
    }
    disconnectedCallback(){this.observer?.disconnect();}
    update(){
      this.variant=C.findVariant(this.product.variants,this.choices);
      this.quantity=Number(this.quantityInput.value);
      this.allocations=this.subscriptionsEnabled?C.supportedAllocations(this.variant,this.product.sellingPlans):[];
      if(this.planId&&!this.allocations.some(a=>String(a.planId)===String(this.planId))){
        this.planId=null;
        if(this.purchaseType==='subscription'){
          this.purchaseType=null;this.error.textContent=t('no_plan');
          this.form.querySelectorAll('[name="purchase-choice"]').forEach(input=>{input.checked=false;});
        }
      }
      if(this.variant?.requiresPlan&&this.purchaseType==='once'){
        this.purchaseType=null;this.form.querySelector('[value="once"]').checked=false;
      }
      this.variantInput.value=this.variant?String(this.variant.id):'';
      this.planInput.value=this.purchaseType==='subscription'?String(this.planId||''):'';
      if(this.variant){
        const rule=this.variant.quantityRule||{};
        this.quantityInput.min=String(rule.min||1);this.quantityInput.step=String(rule.increment||1);
        if(rule.max)this.quantityInput.max=String(rule.max);else this.quantityInput.removeAttribute('max');
        if(this.quantity<(rule.min||1)){this.quantity=rule.min||1;this.quantityInput.value=String(this.quantity);}
        const url=new URL(location.href);url.searchParams.set('variant',this.variant.id);
        if(this.planId)url.searchParams.set('selling_plan',this.planId);else url.searchParams.delete('selling_plan');
        history.replaceState(null,'',url);
        if(this.variant.mediaId)showMedia(this.querySelector('[data-gallery]'),this.variant.mediaId);
      }
      this.querySelectorAll('[data-option-index]').forEach(field=>{
        const index=Number(field.dataset.optionIndex);
        field.querySelectorAll('input').forEach(input=>{
          input.disabled=!this.product.variants.some(v=>v.available&&v.options[index]===input.value&&v.options.every((value,i)=>i===index||this.choices[i]===null||this.choices[i]===value));
        });
      });
      const once=this.querySelector('[data-onetime-card]');
      once.hidden=Boolean(this.variant?.requiresPlan||this.product.requiresPlan);
      const subscribe=this.querySelector('[data-subscribe-card]');
      const firstRecurringPlan=this.product.sellingPlans.find(p=>p.recurring);
      subscribe.hidden=this.variant?this.allocations.length===0:!this.subscriptionsEnabled||!firstRecurringPlan;
      subscribe.querySelector('input').disabled=this.allocations.length===0;
      const selected=this.allocations.find(a=>String(a.planId)===String(this.planId));
      const displayed=selected||this.allocations[0];
      const plan=this.product.sellingPlans.find(p=>String(p.id)===String(displayed?.planId));
      const showMoney=value=>this.salesEnabled&&Number.isFinite(value)&&value>0?money(value):t('price_pending');
      const basePrice=this.variant?.price;
      this.querySelector('[data-onetime-price]').textContent=showMoney(basePrice*this.quantity);
      this.querySelector('[data-subscription-price]').textContent=displayed?showMoney(displayed.price*this.quantity):'—';
      this.querySelector('[data-plan-name]').textContent=plan?.name||firstRecurringPlan?.name||'';
      const saved=C.savings(basePrice||0,displayed?.price||basePrice||0,this.quantity);
      const saving=this.querySelector('[data-saving]');
      saving.hidden=!this.salesEnabled||saved.amount<=0||!displayed;
      saving.textContent=`${t('save')} ${money(saved.amount)} / ${saved.percentage}%`;
      this.querySelector('[data-subscribe-label]').textContent=this.salesEnabled&&saved.amount>0?t('subscribe_save'):t('subscribe');
      const picker=this.querySelector('[data-plan-picker]');
      picker.hidden=this.purchaseType!=='subscription'||this.allocations.length<2;
      const frequency=picker.querySelector('select');
      const choices=this.allocations.map(a=>{
        const p=this.product.sellingPlans.find(p=>String(p.id)===String(a.planId));
        const option=document.createElement('option');option.value=String(a.planId);option.textContent=p?.name||'';option.selected=String(a.planId)===String(this.planId);return option;
      });
      frequency.replaceChildren(...choices);
      const recurring=this.querySelector('[data-recurring]');
      recurring.hidden=this.purchaseType!=='subscription'||!selected;
      const total=selected&&this.purchaseType==='subscription'?selected.price*this.quantity:basePrice*this.quantity;
      this.querySelector('[data-main-price]').textContent=showMoney(total)+(this.salesEnabled&&Number.isFinite(total)&&total>0?` · ${this.purchaseType==='subscription'?t('per_delivery'):t('one_time')}`:'');
      this.querySelector('[data-billing-summary]').textContent=`${t('recurring')} ${plan?.name||''}. ${showMoney(total)} ${t('per_delivery')}.`;
      const future=this.querySelector('[data-future-price]');
      const changes=selected?.adjustments||[];
      future.hidden=changes.length<2;
      if(changes.length>1){
        const firstCycles=plan?.adjustments?.[0]?.order_count;
        future.textContent=`${t('initial')}: ${showMoney(changes[0].price*this.quantity)}${firstCycles?` (${firstCycles} ${t('deliveries')})`:''}. ${t('then')}: ${showMoney(changes[1].price*this.quantity)} ${t('per_delivery')}.`;
      }
      const count=this.variant?.unitCount;
      this.querySelector('[data-pack-total]').textContent=count>0?`${count*this.quantity} ${t('diapers')} · ${count} ${t('per_pack')}`:`${this.quantity} ${this.quantity===1?t('pack'):t('packs')}`;
      let label=t('add');
      if(!this.salesEnabled)label=t('launch');
      else if(!this.variant)label=t('choose_options');
      else if(!this.variant.available)label=t('sold_out');
      else if(!this.purchaseType)label=t('choose_purchase');
      this.button.textContent=this.busy?t('adding'):label;
      this.button.disabled=this.busy||!this.salesEnabled||Boolean(this.variant&&!this.variant.available);
      this.querySelector('[data-sticky-summary]').textContent=this.variant?`${this.choices.join(' / ')} · ${showMoney(total)}`:t('choose_options');
      this.dispatchEvent(new CustomEvent('cooshier:variant-change',{bubbles:true,detail:{variant:this.variant,purchaseType:this.purchaseType,sellingPlanId:this.planId,quantity:this.quantity}}));
    }
    async submit(){
      if(this.busy)return;
      this.error.textContent='';
      let line;
      try{line=C.makeLine({variant:this.variant,quantity:this.quantity,purchaseType:this.purchaseType,planId:this.planId,plans:this.product.sellingPlans,salesEnabled:this.salesEnabled});}
      catch(error){this.error.textContent=!this.variant?t('choose_options'):t(error.message);this.error.scrollIntoView({block:'nearest'});return;}
      this.busy=true;this.update();
      try{
        const result=await api('cart/add.js',{items:[line]});
        // A successful add must never be retried because section rendering failed.
        try{await renderCart(result.sections);openDialog(document.getElementById('CartDrawer'));status(t('added'));}
        catch{location.assign(config.cartUrl);}
      }catch(error){this.error.textContent=error.message||t('error');}
      finally{this.busy=false;this.update();}
    }
  }
  if(!customElements.get('cooshier-product'))customElements.define('cooshier-product',CooshierProduct);
})();
